var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.482 8.99695C18.0399 7.74174 16.7573 6.45915 15.5021 7.01703L10.5018 9.23937C10.1625 9.39019 9.89118 9.66153 9.74036 10.0008L7.51801 15.0011C6.96014 16.2563 8.24272 17.5389 9.49794 16.981L14.4982 14.7587C14.8375 14.6079 15.1089 14.3365 15.2597 13.9972L17.482 8.99695ZM11.4898 10.9888L15.1264 9.37263L13.5102 13.0092L9.87362 14.6254L11.4898 10.9888Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 23C18.5751 23 23.5 18.0751 23.5 12C23.5 5.92487 18.5751 1 12.5 1C6.42487 1 1.5 5.92487 1.5 12C1.5 18.0751 6.42487 23 12.5 23ZM12.5 20.9869C7.53665 20.9869 3.51306 16.9633 3.51306 12C3.51306 7.03665 7.53665 3.01306 12.5 3.01306C17.4633 3.01306 21.4869 7.03665 21.4869 12C21.4869 16.9633 17.4633 20.9869 12.5 20.9869Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.781f2694d0a8c13f2e9543abc942542b.svg";
export { ForwardRef as ReactComponent };